import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../account/account.service';
import { AccountAverage } from '../../../account/account.model';
import { HorizontalListData } from 'common';
import { ProductAveragesListAdapter } from './product-averages-list.data';

@Component({
    selector: 'ifb-product-averages-list',
    templateUrl: './product-averages-list.component.html',
    styleUrls: ['./product-averages-list.component.scss'],
    providers: [ProductAveragesListAdapter],
    standalone: false
})
export class ProductAveragesListComponent implements OnInit {
  data: AccountAverage[] = [];
  index = 0;
  listItems: HorizontalListData[];

  constructor(
    private readonly accountService: AccountService,
    private readonly adapter: ProductAveragesListAdapter
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(): void {
    this.accountService.averagesInfo()
      .subscribe((data) => {
        this.data = data;
        this.refreshListData();
      });
  }

  private refreshListData(): void {
    this.listItems = this.adapter.adaptListData(this.data, this.index);
  }

  prevProduct(): void {
    if (this.index > 0){
      this.index -= 1;
      this.refreshListData();
    }
  }

  nextProduct(): void {
    if (this.index < this.data.length - 1) {
      this.index += 1;
      this.refreshListData();
    }
  }
}
